interface SortingParam {
  id: string;
  desc: boolean;
}

/** `aria-sort` value for a header cell: `undefined` when the column isn't
 * sortable, otherwise the current sort direction or `'none'`. */
export const getAriaSort = (
  isSortable: boolean,
  sortedItem: SortingParam | undefined
): 'ascending' | 'descending' | 'none' | undefined => {
  if (!isSortable) return undefined;

  if (!sortedItem) return 'none';

  return sortedItem.desc ? 'descending' : 'ascending';
};

/** Human-readable sort state appended to the sort button's `aria-label`. */
export const getSortStateLabel = (
  sortedItem: SortingParam | undefined
): string => {
  if (!sortedItem) return 'not sorted';

  return sortedItem.desc ? 'sorted descending' : 'sorted ascending';
};
